module.exports = __webpack_public_path__ + "img/product-shot_05.d065ad87.jpg";